import styled from 'styled-components';
import LeftArrowIcon from '../Assets/left-arrows.svg';
import RightArrowIcon from '../Assets/right-arrows.svg';
import DownloadBTN from '../Assets/DownloadBTN.svg';
import { H2 } from '../style-comps/Common.styles';

export const ListingContainer = styled.div`
  width: 100%;
  min-height: 350px;
  position: relative;
  border-radius: 8px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border: 0.1px solid #ECECEC;
  display: flex; /* 確保內部內容對齊 */
  flex-direction: column;
  align-items: center;
`;


export const ListingsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: left;
  }
`;

export const ListingsColumn = styled.div`
  flex: 1;
  margin: 0 12px;
  width: 100%; /* 讓列表填滿父容器 */

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ListingHeader = styled(H2)`
    color: #333;
    margin-bottom: 16px;
    padding:24px;
    width:100%;


     @media (max-width: 768px) {
     padding:16px;
    }
`;

export const Table = styled.table`
  width: 100%; 
  border-collapse: collapse;
  overflow-x: auto;
  display: block; /* 讓表格不會超過父容器 */
  table-layout: fixed; // 這行是關鍵

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const TableRow = styled.tr`
    border-bottom: 1px solid #ECECEC;
    

    
`;

export const TableCell = styled.td`
    padding: 18px;
    text-align: center; // 讓內容居中
    color: #000;
    font-size:14px;
    width: 25%; // 如果有 4 列
    height: 60px;  // 強制設定高度
    overflow: hidden;  // 避免內容超出時影響表格
    text-overflow: ellipsis;
    white-space: nowrap;  // 避免換行

  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 12px;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 18px;
    text-align: center;
    background-color: #fff;
    font-weight: normal;
    color: #697077;
    border-bottom: 1px solid #ECECEC;
    width: 25%; // 如果有 4 列

  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 12px;
  }
`;

export const TypeCell = styled.span`
    color: #fff;
    font-weight: normal;
    border-radius: 4px;
    padding: 0 8px;
   
    background-color: ${(props) =>
    props.type === 'PDF' ? '#61CBC9' : '#FF6600'};

        @media (max-width: 768px) {
        padding: 8px 16px;
        font-size:14px;
    }
`;

export const DownloadIcon = styled.span`
    cursor: pointer;
    display: inline-block;
    width: 18px;
    height: 18px;
    background-image: url(${DownloadBTN});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-3px);
    }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0; 
  width: 100%;
  padding: 10px 0;
  margin-top: 20px; 

  @media (max-width: 768px) {
    position: absolute; /* 讓 Pagination 放在內容下面，不會重疊 */
    margin-top: 10px; /* 增加間距 */
    flex-wrap: wrap; /* 讓按鈕換行 */
  }
`;

export const PaginationButton = styled.button`
  margin: 0 5px;
  padding: 10px;
  font-size: 16px;
  border: none;
  background-color: ${(props) => (props.active ? '#61CBC9' : 'transparent')};
  color: ${(props) => (props.active ? '#fff' : '#333')};
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px; /* 調整按鈕大小 */
  height: 32px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${(props) => (!props.disabled && !props.active ? '#61CBC9' : '#61CBC9')};
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
    font-size: 14px;
    padding: 8px;
  }
`;

export const LeftArrow = styled.span`
    margin-right: 8px;
    width: 24px;
    height: 24px;
    background-image: url(${LeftArrowIcon});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export const RightArrow = styled.span`
    margin-left: 8px;
    width: 24px;
    height: 24px;
    background-image: url(${RightArrowIcon});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;
